import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder } from '@angular/forms';
import { createPopper } from '@popperjs/core';
import { MatPasswordStrengthComponent } from '@angular-material-extensions/password-strength';
import swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { LoginService } from 'src/app/layout/services/login.service';
import { ProfileService } from '../../profile.service';
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();

@Component({
  selector: 'password-reset-update',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends FeaturesBaseComponent implements OnInit, AfterContentChecked {
  @Output() closeReset: EventEmitter<any> = new EventEmitter();
  resetForm: FormGroup;
  password: string;
  showDetails: boolean = false;
  color = '';

  @ViewChild('passwordComponentWithConfirmation', { static: true })
  passwordComponentWithConfirmation: MatPasswordStrengthComponent;
  isClose: any;

  constructor(private cdref: ChangeDetectorRef, private router: Router,
    private formBuilder: FormBuilder, private profileService: ProfileService
  ) {
    super();
    this.isClose = true;
  }
  ngAfterContentChecked() {
    this.passwordComponentWithConfirmation.max = 12;
    this.cdref.detectChanges();

  }

  ngOnInit() {
    super.ngOnInit();

    // this.passwordComponentWithConfirmation.passwordFormControl.valueChanges.subscribe(() => {
    //   console.log('passwordFormControl form control = ', this.passwordComponentWithConfirmation.passwordFormControl);
    // });

    // this.passwordComponentWithConfirmation.passwordConfirmationFormControl.valueChanges.subscribe(() => {
    //   console.log('passwordFormControl form control = ', this.passwordComponentWithConfirmation.passwordConfirmationFormControl);
    // });
    this.resetForm = new FormGroup({
      password: new FormControl(this.passwordComponentWithConfirmation.passwordFormControl),
      confirmPassword: new FormControl(this.passwordComponentWithConfirmation.passwordConfirmationFormControl),
    });
  }

  toggleHint() {
    this.showDetails = !this.showDetails;
  }

  onStrengthChanged(strength: number) {
    // console.log('password strength = ', strength);
  }

  submit() {
    if (this.resetForm.value.password.status == "INVALID" || this.resetForm.value.confirmPassword.status == "INVALID") {
      // console.log(this.resetForm.value.password)
      // console.log(this.resetForm.value.confirmPassword) 
      return;
    }
    let _userId = helper.decodeToken(localStorage.getItem('accessToken')).user_id;
    if (_userId && this.resetForm.value.confirmPassword.value) {
      let httpParams = new HttpParams()
        .set('userId', _userId)
        .set('newPassword', this.resetForm.value.confirmPassword.value)
      this.profileService.resetPassword(httpParams).subscribe(res => {
      
        if (res.httpcode == 200) {
          this.toastrService.success(
            'Password reset successfully!', 'Success'
          )
          this.closeReset.emit(this.isClose)
        }
      })
    }

  }
  getPasswordHint():string{

    return `should contain at least one lower character.\n should contain at least one upper character.\n should contain at least one digit character.\n should contain at least one special character.\nshould contain at least 8 characters.`

  }
}